import { createFileRoute } from '@tanstack/react-router'

import {
  type Analysis,
  AnalysisGenerateSection,
  AnalysisReportSection,
  AnalysisSkeleton,
  AnalysisViewControl,
  useAnalysis,
  useFetchAnalysis,
  useLoadingAnalysis,
} from '@/modules/analysis'
import { DeleteAnalysisDialog } from '@/modules/analysis/components/DeleteAnalysisDialog'
import {
  type Project,
  useFetchProject,
  useLoadingProject,
  useProject,
} from '@/modules/projects'

export const Route = createFileRoute('/_authenticated/projects/$slug/analysis')(
  { component: ProjectAnalysisPage },
)

export function ProjectAnalysisPage() {
  const analysis = useAnalysis()
  const isLoadingAnalysis = useLoadingAnalysis()
  const project = useProject()
  const isLoadingProject = useLoadingProject()

  const { slug } = Route.useParams()
  useFetchProject(slug)
  useFetchAnalysis(slug)

  if (isLoadingProject || isLoadingAnalysis) {
    return <AnalysisSkeleton />
  }

  return (
    <AnalysisViewControl project={project as Project}>
      <DeleteAnalysisDialog />
      <AnalysisGenerateSection
        project={project as Project}
        analysis={analysis as Analysis}
      />
      <AnalysisReportSection slug={slug} analysis={analysis as Analysis} />
    </AnalysisViewControl>
  )
}
